import React from 'react';
import S, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import styled, { CSSProperties } from 'styled-components';
import { darken } from 'polished';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
const StyledSelect = styled(S)`
    width: 100%;

    &.MuiInputBase-root {
        height: 72px;
        background: transparent;
        border-radius: 12px;
        padding-right: 12px;
        border: 1px solid #fff;

        .MuiSelect-select {
            color: #fff;

            font-size: 16px;
            padding-left: 32px;
            ${({ theme }) => theme.mediaWidth.upToSmall`
                font-size: 12px;
                padding-left: 12px;
            `};
        }
        .MuiSelect-root {
            padding: 0 32px;
            padding-right: 50px;
        }
        .MuiOutlinedInput-notchedOutline {
            border: none;
        }
        color: ${({ theme }) => theme.c.white01};

        font-size: 12px;
        border-radius: 20px;
        &:focus,
        &:hover,
        &:active {
            border: 1px solid ${({ theme }) => darken(0.2, theme.c.white01)};
        }

        &::after,
        &::before {
            border: none !important;
        }
    }
`;

const ArrowDown = styled(KeyboardArrowDownIcon)`
    color: #fff !important;
    /* top: unset !important; */
    /* right: 4px !important; */
`;

const CustomOption = styled(MenuItem)`
    background-color: #fff !important;
    color: #1c1c1c !important;
    :hover {
        color: ${({ theme }) => theme.c.primary01} !important;
    }
`;

interface Props {
    value?: number | string;
    items: {
        text: string;
        value: number | string;
    }[];
    onChange?(value: any): void;
    className?: string;
    placeholder?: string;
    style?: CSSProperties;
    renderValue?: string;
    disablePlaceholder?: boolean;
}

export default function Select({
    value,
    items,
    onChange,
    className,
    placeholder,
    style,
    renderValue,
    disablePlaceholder = true,
}: Props) {
    const handleChange = (event: SelectChangeEvent<unknown>) => {
        if (onChange) {
            onChange(event.target.value as any);
        }
    };
    return (
        <StyledSelect
            labelId="netswap-switch"
            value={value}
            onChange={handleChange}
            className={className}
            IconComponent={ArrowDown}
            displayEmpty
            style={style}
            renderValue={(v) =>
                v
                    ? `${renderValue || ''} ${
                          items.find((i) => i.value === v)?.text
                      }`
                    : placeholder
            }
        >
            <CustomOption value="" disabled={disablePlaceholder}>
                {placeholder}
            </CustomOption>

            {items.map((i, index) => (
                <CustomOption
                    key={index}
                    className="selectOption"
                    value={i.value}
                >
                    {i.text}
                </CustomOption>
            ))}
        </StyledSelect>
    );
}
